"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterActions = void 0;
var react_1 = require("react");
function useFilterActions() {
    var _a = (0, react_1.useState)("ALL"), selectedStatusFilter = _a[0], setSelectedStatusFilter = _a[1];
    var filterActions = (0, react_1.useMemo)(function () { return [
        {
            key: "status",
            label: "Status",
            value: selectedStatusFilter,
            items: [
                { label: "ALL", value: "ALL" },
                { label: "Active", value: "active" },
                { label: "Inactive", value: "inactive" },
            ],
            onChange: setSelectedStatusFilter,
        },
    ]; }, [selectedStatusFilter]);
    var resetFilters = (0, react_1.useCallback)(function () {
        setSelectedStatusFilter("ALL");
    }, []);
    return (0, react_1.useMemo)(function () { return ({
        filterActions: filterActions,
        resetFilters: resetFilters,
    }); }, [filterActions, resetFilters]);
}
exports.useFilterActions = useFilterActions;
